// For more information: https://github.com/flatpickr/flatpickr
import flatpickr from 'flatpickr';
import {French} from 'flatpickr/dist/l10n/fr.js';

const localize = () => {
    if (app.locale === 'fr') {
        flatpickr.localize(French);
    }
};

export default class FlatPickr {

    static initDateTimePicker() {
        localize();
        document.querySelectorAll('[data-datetime-picker]').forEach((inputDatetimePicker) => {
            flatpickr(inputDatetimePicker, {
                altInput: true,
                altFormat: 'j F Y - H:i',
                enableTime: true,
                dateFormat: 'Z',
                time_24hr: true
            });
        });
    }

    static initDateRangePicker() {
        localize();
        document.querySelectorAll('[data-date-range-picker]').forEach((inputRangeDatePicker) => {
            flatpickr(inputRangeDatePicker, {
                altInput: true,
                altFormat: 'd/m/y',
                mode: 'range',
                minDate: 'today',
                dateFormat: 'Y-m-d'
            });
        });
    }

    static initMultipleDatePicker() {
        localize();
        document.querySelectorAll('[data-date-multiple-picker]').forEach((inputRangeDatePicker) => {
            flatpickr(inputRangeDatePicker, {
                altInput: true,
                altFormat: 'd/m/y',
                mode: 'multiple',
                minDate: 'today',
                dateFormat: 'Y-m-d'
            });
        });
    }
}
